import { PrimaryControlsStripExpansionContext } from "@-/dev.improve.haniverse.contexts.primary-controls-strip.expansion";
import { useContext, useEffect, useState } from "react";

/**
 * Subscribes to the expansion registry and returns whether any publisher currently
 * has content registered. Use to gate UI that should only appear when expansion content
 * is available (e.g. the expand/collapse toggle button).
 */
export function usePrimaryControlsStripExpansionHasContent(): boolean {
  const registry = useContext(PrimaryControlsStripExpansionContext);
  const [hasContent, setHasContent] = useState(() => registry.hasContent());

  useEffect(() => {
    setHasContent(registry.hasContent());
    return registry.subscribe(() => {
      setHasContent(registry.hasContent());
    });
  }, [registry]);

  return hasContent;
}
